import { alpha } from '@mui/material/styles';
import { SxStyle } from '@aibees/shared/theme';

export const technologiesIconSx: SxStyle = {
  borderRadius: 0.5,
  border: (p) => `1px solid ${p.palette.primary[100]}`,
  clipPath: 'unset',
};

export const backdropSx: SxStyle = {
  position: 'fixed',
  zIndex: '10000',
  backgroundColor: (p) => alpha(p.palette.common.white, 0.2),
};
